import * as React from 'react';
import { useErrorLog } from '@core-front/error-provider';
import { useTheme } from '@core-front/theme-provider';
const deprecationMap = {
    '#clear': '#close-round',
    '#service-it': 'server',
    '#server-email': '#email',
    '#enduser': '#contact',
    '#file-bills': '#file-bill',
    '#service-box': '#parcel-machine',
    '#close-light': '#close',
    '#star-film': '#star',
    '#service': '#repair',
    '#server-settings': '#settings',
    '#update': '#sync',
    '#processes': '#sync',
    '#feedback': '#chat',
    '#sms': '#chat',
    '#talk-bubble': '#chat',
    '#cloud-line': '#cloud',
    '#activity-monitor': '#watch',
    '#digibox': '#device-digibox',
    '#modem': '#device-router',
    '#mobile-devices': '#devices',
    '#help-round': '#help',
    '#help-circle': '#help',
    '#safe': '#security',
    '#security-internet': '#security',
    '#firewall': '#security',
    '#mailware': '#security',
    '#protective-film': '#security',
    '#music-infinity': '#offering',
    '#service-leasing': '#coins',
    '#play-video': '#video',
    '#play-video-2': '#video',
    '#packet-sport': '#sport',
    '#packet-music': '#music',
    '#packet-russian': '#matryoshka',
    '#packet-lifestyle': '#weather',
    '#packet-children': '#teddybear',
    '#channels': '#service-tv-channels',
    '#arrow-large-down': '#arrow-down',
    '#arrow-large-left': '#arrow-left',
    '#arrow-large-right': '#arrow-right',
    '#arrow-large-up': '#arrow-up',
    '#arrow-medium-down': '#arrow-down',
    '#arrow-medium-left': '#arrow-left',
    '#arrow-medium-right': '#arrow-right',
    '#arrow-medium-up': '#arrow-up',
    '#arrow-left-light': '#arrow-left',
    '#arrow-right-light': '#arrow-right',
    '#plus-circle': '#plus-round',
    '#architecture': '#service-internet',
    '#contact-search': '#search',
    '#internet-lock': '#lock',
    '#minus-circle': '#minus-round',
    '#mobile-simple': '#mobile',
    '#play-round': '#play-circle',
    '#service-business': '#briefcase',
    '#service-tv': '#tv',
    '#speed': '#arrow-up-down',
    '#tech-support': '#technician',
    '#people-arrow': '#user-group',
};
const getAliasName = (name, log) => {
    if (Object.prototype.hasOwnProperty.call(deprecationMap, name)) {
        const substitute = deprecationMap[name];
        log(`"${name}" icon is deprecated. Please use "${substitute}" instead.`);
        return substitute;
    }
    return name;
};
const Icon = (props) => {
    var _a;
    const { getIconPath } = useTheme();
    const { log } = useErrorLog();
    const name = getAliasName(props.modifiers, log);
    const src = getIconPath(name);
    const BEM = () => {
        const classArray = ['icon'];
        if (props.size) {
            classArray.push('icon--' + props.size);
        }
        if (props.align) {
            classArray.push('icon--align-' + props.align);
        }
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    return (React.createElement("svg", { className: BEM(), style: props.style, focusable: "false", "aria-hidden": (_a = props['aria-hidden']) !== null && _a !== void 0 ? _a : true },
        React.createElement("use", { xlinkHref: src, href: src })));
};
export default Icon;
